import { NavLink, Outlet } from 'react-router-dom'

export default function Prints() {
  return (
    <div style={{ padding: 'var(--space-6)' }}>
      <h1 style={{ marginBottom: 'var(--space-4)' }}>Prints</h1>
      <nav
        style={{
          display: 'flex',
          gap: 'var(--space-2)',
          marginBottom: 'var(--space-4)',
          borderBottom: '1px solid var(--color-border)',
        }}
      >
        {[
          { to: '/prints', label: 'Prints', end: true },
          { to: '/prints/products', label: 'Products', end: false },
          { to: '/prints/queue', label: 'Queue', end: false },
        ].map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            end={tab.end}
            style={({ isActive }) => ({
              padding: 'var(--space-3) var(--space-4)',
              fontWeight: 600,
              fontSize: 'var(--font-size-sm)',
              color: isActive ? 'var(--color-primary)' : 'var(--color-text-muted)',
              borderBottom: isActive ? '2px solid var(--color-primary)' : '2px solid transparent',
              marginBottom: -1,
              textDecoration: 'none',
            })}
          >
            {tab.label}
          </NavLink>
        ))}
      </nav>
      <Outlet />
    </div>
  )
}
